import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

export const Wrapper = styled.div`
  padding: 16px;
`;

export const Header = styled.h1`
  color: #1c232c;
  font-size: 48px;
  font-weight: bold;
  text-align: center;
  letter-spacing: 0.5px;
  line-height: 48px;
  margin: 48px auto;
`;

export const VenuesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 auto;
  max-width: 1168px;
  justify-content: center;
  padding-bottom: 20vh;
`;

export const VenueContainer = styled.div``;

export const Venue = styled.div<{ disabled?: boolean }>`
  width: 272px;
  height: 112px;
  margin: 8px;
  box-sizing: border-box;
  padding: 16px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.16), 0px 1px 3px 0px rgba(0, 0, 0, 0.16);

  cursor: pointer;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  vertical-align: top;

  opacity: ${(props) => (props.disabled ? 0.7 : 1)};
  pointer-events: ${(props) => (props.disabled ? 'none' : 'auto')};
  transition: all 0.2s;

  &:active {
    transform: scale(0.98);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.22), 0 1px 1px rgba(0, 0, 0, 0.34);
  }
`;

export const Loading = styled.h1`
  position: fixed;
  top: 45%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const VenueTitle = styled.p`
  font-size: 14px;
  color: black;
  margin: 0;
  font-weight: 600;
`;

export const VenueLabel = styled.p`
  font-size: 12px;
  color: #545960;
  margin: 0;
  margin-top: 2px;
`;

export const VenueLink = styled(Link)`
  text-decoration: none;
`;

export const LogoutWrapper = styled.div`
  max-width: 200px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
`;
